var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Activate',{attrs:{"invite":_vm.invite,"loader":_vm.loader,"disableForm":_vm.disableForm}})}
var staticRenderFns = []

export { render, staticRenderFns }